import { Controller } from "@hotwired/stimulus"

// InfoTip.js: il clic apre e chiude il riquadro; perdendo il fuoco si chiude dopo 120 ms
// (onBlur={() => setTimeout(() => setOpen(false), 120)}).
export default class extends Controller {
  static targets = ["panel"]

  disconnect() { clearTimeout(this.timer) }

  toggle() { this.panelTarget.hidden = !this.panelTarget.hidden }

  blur() {
    clearTimeout(this.timer)
    this.timer = setTimeout(() => { this.panelTarget.hidden = true }, 120)
  }
}
